import { createSelector } from 'reselect';

import { ActionRef } from '@/App/types/actionRef';
import { ScreenRef } from '@/App/types/screenRef';
import { getDisplayRulesMetadata } from '@/features/displayRules/getDisplayRulesMetadata';
import { selectDisplayRuleStateMap } from '@/features/displayRules/selectDisplayRuleStateMap';

export const selectFieldMaxLength = (screen: ScreenRef, action: ActionRef, id: string) =>
  createSelector([selectDisplayRuleStateMap], (displayRules) => {
    const currentMetadata = getDisplayRulesMetadata(displayRules, screen, action);
    return currentMetadata ? (currentMetadata[id] ? currentMetadata[id]!.maxLength : null) : null;
  });
